export default "__VITE_ASSET__Ba1NVC3x__"